/** Непустой VITE_* URL или fallback (локальный бэкенд). */
function envUrl(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim()
  return trimmed ? trimmed : fallback
}

const DEFAULT_BACKEND = 'http://localhost:3000'

/**
 * Централизованная конфигурация оверлея.
 * Все параметры берутся из VITE_* env-переменных (.env / .env.local / K8s ConfigMap).
 */
export const OVERLAY_CONFIG = {
  /** REST API бэкенда (auth/overlay/session, public-key, …). */
  API_BASE_URL: envUrl(import.meta.env.VITE_API_URL, DEFAULT_BACKEND),

  /** Origin Socket.IO (без path); клиент подключается к `${WS_BASE_URL}/overlay`. */
  WS_BASE_URL: envUrl(import.meta.env.VITE_WS_URL, DEFAULT_BACKEND),

  /** Макс. одновременно отображаемых эффектов (только НЕ-bypass, см. isQueueBypassEvent) */
  QUEUE_MAX_CONCURRENT: 2,

  /**
   * Мягкий лимит одновременно отрисованных виджетов в одной зоне (ZoneLayoutContext).
   * Сверху лимита виджеты не удаляются и не теряют состояние/данные —
   * они просто не монтируются в DOM зоны, пока не освободится место и
   * перестановка (reconcileZone) не подтянет их вверх по приоритету.
   */
  ZONE_MAX_CONCURRENT_WIDGETS: 3,

  /**
   * TTL для событий в pending-очереди (мс).
   * Событие, пролежавшее дольше этого времени, будет тихо удалено.
   * 0 = TTL отключён (хранить вечно).
   */
  QUEUE_PENDING_TTL_MS: 30_000,

  WS_PING_INTERVAL_MS: 25_000,
  WS_RECONNECT_BASE_MS: 1_000,
  WS_RECONNECT_MAX_MS: 30_000,

  FIREWORKS_DEFAULT_DURATION_MS: 4_000,
  TEXT_ALERT_DEFAULT_DURATION_MS: 4_000,
  DONATION_ALERT_DEFAULT_DURATION_MS: 6_000,
} as const

export type OverlayConfig = typeof OVERLAY_CONFIG
